import { useAuth } from 'react-oidc-context';
import { useAnalyticsSession } from '@consolidocs-ui/analytics';

/** Tells analytics which super admin is signed in, from their ID token. */
export const useAnalyticsUser = (): void => {
  const { user } = useAuth();
  const profile = user?.profile;
  const name = [profile?.given_name, profile?.family_name]
    .filter(Boolean)
    .join(' ');

  useAnalyticsSession(
    profile
      ? {
          id: profile.sub,
          email: profile.email,
          name: name || profile.name,
          properties: { role: 'super-admin' },
        }
      : null
  );
};
